import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'
import getters from './getters'
import app from './modules/app'
import officialWebsite from './modules/officialWebsite'

// Vuex 持久化插件：把 Vuex 内全部 state 保存到 localStorage，刷新页面后自动恢复。
const vuexLocal = new VuexPersistence({
    key: 'saas-web-store',
    storage: window.localStorage,
})

// Vuex 根仓库：只负责组合模块，具体状态放到 modules 里维护。
const store = createStore({
    modules: {
        app,
        // 官网模块里的预约联系方式缓存会随 vuex-persist 一起写入 localStorage。
        officialWebsite,
    },
    getters,
    plugins: [vuexLocal.plugin],
})

export default store
